<!-- 银行数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>

        <div>
            <div class="demo-drawer__content data_action_form">
                <div class="page_title">
                    <el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false">
                    </el-alert>
                </div>
                <el-card>
                    <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo"
                        size="mini" :show-message="false">
                        <el-row slot="">
                            <el-form-item label="抵扣方式" prop="deductionMethod"
                                :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                <label slot="label" :style="$common.labelStyle('抵扣方式')" v-html="'抵扣方式'"></label>
                                <el-radio-group v-model="sendDataInfo.deductionMethod" @change="chRa">
                                    <el-radio-button label="0">费用票</el-radio-button>
                                    <el-radio-button label="1">余额</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                             <el-form-item label="抵扣金额" prop="payMoney" v-if="sendDataInfo.deductionMethod == 0"
                                :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                <label slot="label" :style="$common.labelStyle('抵扣金额')" v-html="'抵扣金额'"></label>
                                <el-input clearable v-model="sendDataInfo.payMoney" readonly
                                    @keyup.enter.native="openSearch('342410041921536', 0, 'payMoney', 'payMoney')">
                                    <el-button
                                        @click="openSearch('342410041921536', 0, 'payMoney', 'payMoney')"
                                        slot="append" icon="el-icon-search">
                                    </el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="抵扣金额" prop="payMoney" v-if="sendDataInfo.deductionMethod == 1"
                                type="number" :rules="[{ required: true, trigger: ['blur', 'change'] }]" >
                                <label slot="label" :style="$common.labelStyle('抵扣金额')" v-html="'抵扣金额'"></label>
                                <el-input clearable v-model="sendDataInfo.payMoney" readonly>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="抵扣比例" prop="proportion" v-if="sendDataInfo.deductionMethod == 1"
                                type="number" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                <label slot="label" :style="$common.labelStyle('抵扣比例')" v-html="'抵扣比例'"></label>
                                <el-input clearable v-model="sendDataInfo.proportion">
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="扣费金额" prop="deductionMoney" v-if="sendDataInfo.deductionMethod == 1"
                                :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                <label slot="label" :style="$common.labelStyle('扣费金额')" v-html="'扣费金额'"></label>
                                <el-input clearable v-model="sendDataInfo.deductionMoney" readonly>
                                </el-input>
                            </el-form-item>
                        </el-row>
                    </el-form>
                    <!-- 明细信息 -->
                    <el-table stripe :data="mxData" :height="mxHeight" border v-if="sendDataInfo.deductionMethod == 0"
                        style="width: 100%" highlight-current-row size="mini">
                        <el-table-column 
                            v-for="(tableValye, tableKey) in mxForm" :key="tableKey"
                            :prop="tableValye.entityField" :label="tableValye.showField"
                            show-overflow-tooltip :min-width="tableValye.fieldWeight">
                            <template slot-scope="scope">
                                <!-- 开票日期 -->
                                <template v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </template>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a
                                        @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                                </span>
                                <!-- 抵扣比例 -->
                                <el-input v-else-if="tableValye.entityField == 'proportion'" min="0" max="100" v-model="mxData[scope.$index][tableValye.entityField]" @input="calculatePrice(0, scope.$index)" >
                                    <template slot="append">%</template>
                                </el-input>
                                <!-- 扣费金额 -->
                                <el-input v-else-if="tableValye.entityField == 'deductionMoney'" :maxlength="$store.state.inputLength" v-model="mxData[scope.$index][tableValye.entityField]" @input="calculatePrice(1, scope.$index)">
                                </el-input>
                                <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                                <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 4">确定</el-button>
                    </div>
                </div>
            </div>

        </div>
        <!-- <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog> -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeMultiple ref="searchSchemeMultiple" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "updateFeeticketgenerate",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                "coId": '',
                coName: '',
                "deductionMethod": '0',
                "fgId": '',
                "payMoney": '',
                "proportion": '',
                "deductionMoney": ''
            },
            showTabs: "",
            formDataList: [],
            userOneList: [],
            seId: "",
            seWidth: "",
            height: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            smId: "",
            parentSearchData: {
            },
            tables: false,
            mxHeight: 400,
            tabForm: [],
            mxForm: [],
            footForm: [],
            mxData: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.payMoney": {
            handler: function (newValue, oldValue) {
                if (newValue != '' && this.sendDataInfo.proportion != '') {
                    this.sendDataInfo.deductionMoney = newValue * (this.sendDataInfo.proportion / 100)
                }
            },
            deep: true,
        },
        "sendDataInfo.proportion": {
            handler: function (newValue, oldValue) {
                if (newValue != '' && this.sendDataInfo.payMoney != '') {
                    this.sendDataInfo.deductionMoney = newValue * (this.sendDataInfo.payMoney / 100)
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        chRa() {
            this.sendDataInfo.deductionMoney = ''
        },
        getSelect() {
            this.sendDataInfo.payMoney = 0
            this.sendDataInfo.deductionMoney = 0
            this.mxData = JSON.parse(JSON.stringify(this.$refs.searchSchemeMultiple.multipleSelection))
            this.mxData.forEach(v=>{//invoicingMoney ticketCostmoney
                v.proportion = 100
                v.deductionMoney = v.invoicingMoney
                this.sendDataInfo.payMoney = this.$common.getDecimalInfo(
                    3,
                    NP.plus(this.sendDataInfo.payMoney, parseFloat(v.invoicingMoney))
                );
                // this.sendDataInfo.payMoney+=parseFloat(v.invoicingMoney)
            })
            this.DialogVisible = false;
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) return
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
                    .printJurId)
            } else {
                return
            }
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        changeInputModel(val) {
            console.log('changeInputModel', val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.sendDataInfo.deductionMoney = parseFloat(val.invoicingMoney)
                this.mxData = [val]
                this.mxData.forEach(v=>{
                    v.proportion = 100
                    v.deductionMoney = v.invoicingMoney
                })
                // this.paramValue(val)
            }
        },
        // 计算价格
        calculatePrice(cate, index) {
            var info = JSON.parse(JSON.stringify(this.mxData[index]));
            if(cate === 1){// 金额
                if (info.deductionMoney == '') info.deductionMoney = 0
                // 计算金额 开票*比例
                let bl =  this.$common.getDecimalInfo(3,(NP.divide(parseFloat(info.deductionMoney), parseFloat(info.invoicingMoney))*100));
                // let bl = (NP.divide(parseFloat(info.deductionMoney), parseFloat(info.invoicingMoney))*100).toFixed(2);
                if (bl > 100) {
                    this.mxData[index].proportion = 100
                    this.mxData[index].deductionMoney = this.$common.getDecimalInfo(3, NP.times(parseFloat(info.invoicingMoney), 1));
                } else {
                    this.mxData[index].proportion = bl
                }
                // this.mxData[index].proportion = this.$common.getDecimalInfo(3, NP.times(parseFloat(info.invoicingMoney), (bl/100)));
                this.sendDataInfo.payMoney = this.mxData.reduce((p,c)=>{
                    let num = c.deductionMoney? parseFloat(c.deductionMoney): 0
                    return p+num
                }, 0)
            } else {// 比例
                if (info.proportion == '') info.proportion = 0
                let bl = parseFloat(info.proportion)
                if(bl<0 || bl>100){
                    this.mxData[index].proportion = ""
                    return this.$message({
                        message: '请输入正确比例',
                        type: "error",
                    }); 
                }
                // 计算金额 开票*比例
                this.mxData[index].deductionMoney = this.$common.getDecimalInfo(3, NP.times(parseFloat(info.invoicingMoney), (bl/100)));
                this.sendDataInfo.payMoney = this.mxData.reduce((p,c)=>{
                    let num = c.deductionMoney? parseFloat(c.deductionMoney): 0
                    return p+num
                }, 0)
            }
        },

        initActionBox(sendDataInfo) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dataActionBox.actionType = 0;
                    this.$emit('drawerCancel')
                    this.tables = false;
                    this.init();
                    this.$refs[sendDataInfo][0].resetFields();
                })
                .catch(() => {
                });
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.deductionMethod = '0'
        },


        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.init()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "生成计算";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (let key in oldData) {
                    this.sendDataInfo[key] = oldData[key];
                }
            } else if (this.dataActionBox.actionType == 4) {
                this.dataActionBox.boxTitle = "抵扣";
                this.dataActionBox.openMode = "rtl";
                this.sendDataInfo.coName = oldData.coName
                this.sendDataInfo.coId = oldData.coId
                this.parentSearchData.coId = oldData.coId
                this.sendDataInfo.payMoney = oldData.noPayMoney
                this.sendDataInfo.fgId = oldData.fgId
            } else {
                this.tables = true
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            }
            this.$nextTick(() => {
                //计算主表单高度,el-form主表单需要加上ref=”sendDataInfo”
                var sheight1 = this.$refs.sendDataInfo.$el.clientHeight
                // var formBtnHeight = document.querySelector('.detailForm').offsetHeight
                this.mxHeight = document.documentElement.clientHeight - sheight1 - 200
                //(data中需要定义mxHeight,230可以根据明细表格有无操作按钮进行调整)
            })
            this.filterMainField()
        },
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            sendData.deacFtMoneyDataList = JSON.parse(JSON.stringify(this.mxData));
            var responseData = await this.$http.updateFeeticketgenerate(sendData);
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit('drawerCancel', true)
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                        .jurconfigform[index])
                }
            })
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.foot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    padding: 14px 0;
    z-index: 999;
}

.foot .el-form {
    margin-left: 20px;
}

.foot .el-form .el-form-item {
    margin-bottom: 0;
}

.el-drawer {
    outline: none;
}

.mb {
    margin-bottom: 0;
}

.newInput {
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

.el-picker-panel a {
    text-decoration-line: none !important;
}
</style>